// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import VerifyIdentity from '../VerifyIdentity/VerifyIdentity';

// Selectors
import {
  getEmail,
  getPhone,
  getObfuscatedBy
} from 'store/reducers/appointment/contactInfo/selectors';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';

// Actions
import { verifyIdentity } from 'store/reducers/verifyIdentity/actions';
import {
  setEmail,
  setObfuscatedBy
} from 'store/reducers/appointment/contactInfo/actions';
// Types
import type { State } from 'types/redux';
import type { Props } from './VerifyIdentity';

const mapStateToProps = (state: State): $Shape<Props> => ({
  email: getEmail(state),
  phone: getPhone(state),
  obfuscatedBy: getObfuscatedBy(state),
  dealerCountryCode: getDealerCountryCode(state)
});

const mapDispatchToProps = { verifyIdentity, setEmail, setObfuscatedBy };

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(VerifyIdentity);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/VerifyIdentity/VerifyIdentityContainer.js